import { LOCATION_COLORS } from './colors';

export const LOCATION_OPTIONS = [
  { value: 'board', label: 'Board', dot: LOCATION_COLORS.board },
  { value: 'backlog', label: 'Backlog', dot: LOCATION_COLORS.backlog },
];

export const LOCATION_OPTIONS_VERBOSE = [
  { value: 'board', label: 'Show on Board', dot: LOCATION_COLORS.board },
  { value: 'backlog', label: 'Backlog', dot: LOCATION_COLORS.backlog },
];
